import { getRandomUUID } from 'Utils/GetRandomUUID';
import { PreAuthParams } from 'Utils/PreAuthParams';

// Borrowed directly from `fox-webapp` repository
// https://github.com/foxcorp-product/fox-webapp/blob/develop/apps/core/src/hooks/useAddPreAuthParams.ts

// If we need to store information before going to authenticate, we connect it to the state uuid in
// local storage, so after returning from auth, we can be sure whether this is actually the same
// session, or if information for a previous session just wasn't properly cleared.
// Sensitive data shouldn't be stored here, as we can't ensure it'll actually be cleared if the
// sessions don't match.
export const useAddPreAuthParams = () => {
  const addPreAuthParams = (params) => {
    const stateUuid = getRandomUUID();

    const preAuthParams = new PreAuthParams(stateUuid);

    Object.entries(params ?? {}).forEach(([key, value]) => {
      preAuthParams.set(key, value);
    });

    return stateUuid;
  };

  return addPreAuthParams;
};
